import type { State, Actions } from './typings'

import { fetchAllActivityTypesProducer } from '../ActivitiyTypes/state'
import {
  changeContentProducer,
  clearAllFiltersReducer,
  closeContentProducer,
  closeDetailsProducer,
  createLeadActivityProducer,
  deleteActivityProducer,
  fetchAllActivityHistoryFiltersReducer,
  fetchAllActivitiesProducer,
  openContentProducer,
  openDetailsProducer,
  selectAllFiltersReducer,
  toggleFilterByNameReducer,
  updateActivityHistoryReducer,
  updateActivityStatusProducer,
  updateLeadActivityProducer,
  createActivitiesBulkProducer,
} from './actions'

export function reducer(state: State, action: Actions) {
  switch (action.type) {
    case 'activities/openContent':
      return openContentProducer(state, action.payload)
    case 'activities/closeContent':
      return closeContentProducer(state)
    case 'activities/changeContent':
      return changeContentProducer(state, action.payload)
    case 'activities/fetchAll':
      return fetchAllActivitiesProducer(state, action.payload)
    case 'activities/openDetails':
      return openDetailsProducer(state, action.payload)
    case 'activities/closeDetails':
      return closeDetailsProducer(state)
    case 'activities/create':
      return createLeadActivityProducer(state, action.payload)
    case 'activities/update':
      return updateLeadActivityProducer(state, action.payload)
    case 'activityTypes/fetchAll':
      return fetchAllActivityTypesProducer(state, action.payload)
    case 'activities/delete':
      return deleteActivityProducer(state, action.payload)
    case 'activities/updateActivityStatus':
      return updateActivityStatusProducer(state, action.payload)
    case 'activities/createActivitiesBulk':
      return createActivitiesBulkProducer(state)
    case 'activityHistoryFilters/updateAll':
      return fetchAllActivityHistoryFiltersReducer(state, action.payload)
    case 'activityHistory/search':
      return updateActivityHistoryReducer(state, action.payload)
    case 'activityHistoryFilters/toggle':
      return toggleFilterByNameReducer(state, action.payload)
    case 'activityHistoryFilters/clear':
      return clearAllFiltersReducer(state)
    case 'activityHistoryFilters/selectAll':
      return selectAllFiltersReducer(state)
    default:
      return { ...state }
  }
}
